import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserRoleEnum } from '@shared/enums';

import { AuthGuard } from '@auth0/auth0-angular';
import { ErrorPageComponent } from '@shared/components/error-page/error-page.component';
import { UserGuard } from '@core/guards';
import { AccountClearCookiesComponent } from '@shared/components/account-clear-cookies/account-clear-cookies.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'checkmate',
        pathMatch: 'full',
    },
    {
        path: 'checkmate',
        canActivate: [AuthGuard],
        loadChildren: () => import('./features/ckm/ckm.module').then(m => m.CkmModule),
        data: {
            breadcrumb: 'CheckMate',
            roles: [UserRoleEnum.USER, UserRoleEnum.ADMIN],
        },
    },
    {
        path: 'error',
        canActivate: [AuthGuard, UserGuard],
        component: ErrorPageComponent,
        data: {
            breadcrumb: null,
            roles: [UserRoleEnum.USER, UserRoleEnum.ADMIN],
        },
    },
    {
        path: 'Account/ClearCookies',
        component: AccountClearCookiesComponent,
    },
    {
        path: '**',
        redirectTo: 'checkmate',
        pathMatch: 'full',
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
